<template>
    <section class="course-home-section">
        <div class="row titre-course-home">
            <div class="col-12 titre-course-home-text">
                Horaires des cours
            </div>
        </div>
        <div class="row sous-titre-course-home">
            <div class="col-12 sous-titre-course-home-text">
                Hip Hop <span class="sous-titre-course-home-dot">•</span> Breakdance <span class="sous-titre-course-home-dot">•</span> Tricks
            </div>
        </div>
        <div class="row">
            <div class="col-12 course-table-container d-none d-md-block">
                <table class="course-table">
                    <thead>
                        <tr>
                            <th><span class="course-th-label">Jour</span></th>
                            <th><span class="course-th-label">Horaire</span></th>
                            <th><span class="course-th-label">Cours</span></th>
                            <th><span class="course-th-label">Niveau</span></th>
                            <th><span class="course-th-label">Lieu</span></th>
                            <th><span class="course-th-label">Intervenant</span></th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-for="day in courses">
                            <tr v-for="(row, index) in day.rows" :key="day.day + '-' + index">
                                <td v-if="index === 0" :rowspan="day.rows.length" class="course-day-cell">{{ day.day }}</td>
                                <td>{{ row.horaire }}</td>
                                <td>{{ row.cours }}</td>
                                <td>{{ row.niveau }}</td>
                                <td>{{ row.lieu }}</td>
                                <td>{{ row.intervenant }}</td>
                            </tr>
                        </template>
                    </tbody>
                </table>
            </div>
            <div class="col-12 course-cards-mobile d-md-none">
                <div class="course-day-card" v-for="day in courses" :key="'card-' + day.day">
                    <div class="course-day-card-title">{{ day.day }}</div>
                    <div class="course-card-item" v-for="(row, index) in day.rows" :key="day.day + '-m-' + index">
                        <div class="course-card-item-header">
                            <span class="course-card-horaire">{{ row.horaire }}</span>
                            <span class="course-card-niveau">{{ row.niveau }}</span>
                        </div>
                        <div class="course-card-cours">{{ row.cours }}</div>
                        <div class="course-card-meta">{{ row.lieu }} · {{ row.intervenant }}</div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: "CourseHome",
        data() {
            return {
                courses: [
                    {
                        day: "Lundi",
                        rows: [
                            { horaire: "17h20 - 18h20", cours: "Hip Hop / Breakdance Kids", niveau: "5-8 ans", lieu: "Paul Bert - 11 rue de l'Oradou", intervenant: "Tristan" },
                            { horaire: "18h20 - 19h20", cours: "Hip Hop Ado 1", niveau: "9-12 ans", lieu: "Paul Bert - 11 rue de l'Oradou", intervenant: "Tristan" },
                            { horaire: "19h20 - 20h20", cours: "Hip Hop Ado 2", niveau: "13-18 ans", lieu: "Paul Bert - 11 rue de l'Oradou", intervenant: "Tristan" }
                        ]
                    },
                    {
                        day: "Mardi",
                        rows: [
                            { horaire: "17h15 - 18h15", cours: "Initiation Hip Hop", niveau: "6-9 ans", lieu: "Stade Chatrousse - Chamalières", intervenant: "Hicham" },
                            { horaire: "18h15 - 19h15", cours: "Hip Hop / Breakdance", niveau: "9-12 ans débutant", lieu: "Stade Chatrousse - Chamalières", intervenant: "Hicham" },
                            { horaire: "20h00 - 22h00", cours: "Tricking / Breakdance", niveau: "Confirmé", lieu: "Stade de la Mourette - Beaumont", intervenant: "Chris" }
                        ]
                    },
                    {
                        day: "Mercredi",
                        rows: [
                            { horaire: "17h30 - 18h30", cours: "Hip Hop / Breakdance", niveau: "5-10 ans", lieu: "Maison des Associations - Sayat", intervenant: "Rayhan" },
                            { horaire: "18h30 - 20h00", cours: "Hip Hop / Breakdance", niveau: "10-16 ans", lieu: "Maison des Associations - Sayat", intervenant: "Benoit" },
                            { horaire: "20h00 - 21h00", cours: "Hip Hop / Breakdance", niveau: "Adultes", lieu: "Maison des Associations - Sayat", intervenant: "Benoit" }
                        ]
                    },
                    {
                        day: "Jeudi",
                        rows: [
                            { horaire: "17h30 - 19h00", cours: "Hip Hop / Breakdance", niveau: "9-12 ans initié", lieu: "Stade Chatrousse - Chamalières", intervenant: "Hicham" },
                            { horaire: "19h00 - 20h30", cours: "Hip Hop / Breakdance", niveau: "12-18 ans et +", lieu: "Stade Chatrousse - Chamalières", intervenant: "Hicham" }
                        ]
                    },
                    {
                        day: "Vendredi",
                        rows: [
                            { horaire: "17h30 - 18h30", cours: "Hip Hop / Breakdance", niveau: "7-9 ans", lieu: "Gannat - 4 allée Jusserand", intervenant: "Tristan" },
                            { horaire: "18h30 - 19h30", cours: "Hip Hop / Breakdance", niveau: "10-13 ans", lieu: "Gannat - 4 allée Jusserand", intervenant: "Tristan" },
                            { horaire: "19h30 - 20h30", cours: "Hip Hop / Breakdance", niveau: "14-17 ans", lieu: "Gannat - 4 allée Jusserand", intervenant: "Tristan" },
                            { horaire: "20h30 - 21h30", cours: "Hip Hop / Breakdance", niveau: "17+", lieu: "Gannat - 4 allée Jusserand", intervenant: "Tristan" },
                            { horaire: "20h00 - 22h00", cours: "Tricking / Breakdance", niveau: "Tous niveaux", lieu: "Stade de la Mourette - Beaumont", intervenant: "Chris" }
                        ]
                    },
                    {
                        day: "Samedi",
                        rows: [
                            { horaire: "18h00 - 19h00", cours: "Hip Hop / Breakdance", niveau: "Tous niveaux", lieu: "Complexe J-L Pasteur - Cournon", intervenant: "Hicham / Tristan / Rayhan" }
                        ]
                    }
                ]
            };
        }
    }
</script>

<style lang="scss">
    .course-home-section {
        margin-top: 2rem;
        margin-bottom: 2rem;
    }

    .titre-course-home {
        min-height: 15vh;
        align-items: center;
    }

    .titre-course-home-text {
        font-size: 3.5em;
        text-align: center;
    }

    .sous-titre-course-home {
        margin-bottom: 1.5em;
    }

    .sous-titre-course-home-text {
        text-align: center;
        font-size: 1.2em;
        font-weight: 600;
        letter-spacing: .1em;
        text-transform: uppercase;
    }

    .sous-titre-course-home-dot {
        color: #b7972f;
        padding: 0 .3em;
    }

    .course-table-container {
        position: relative;
        overflow-x: auto;
        border-radius: 6px;
        border: 1px solid #b7972f;
    }

    .course-table {
        width: 100%;
        border-collapse: collapse;
        background-color: #14141a;
        color: #fff;
        white-space: nowrap;
    }

    .course-table thead tr {
        height: 3.4em;
    }

    .course-table thead th {
        position: relative;
        padding: .5em .4em;
        border-bottom: 2px solid #b7972f;
    }

    .course-table thead th:not(:last-child)::after {
        content: "";
        position: absolute;
        top: 22%;
        bottom: 22%;
        right: 0;
        width: 1px;
        background: rgba(183, 151, 47, .5);
    }

    .course-th-label {
        display: block;
        margin: 0 .3em;
        padding: .5em .8em;
        border-radius: 5px;
        color: #f0d98c;
        text-transform: uppercase;
        font-weight: 600;
        text-align: center;
        background: linear-gradient(180deg, #5c3f16 0%, #2a1c0a 100%);
        box-shadow: inset 0 0 0 1px rgba(183, 151, 47, .5), 0 2px 4px rgba(0, 0, 0, .4);
    }

    .course-table thead th:first-child {
        border-top-left-radius: 5px;
    }

    .course-table thead th:last-child {
        border-top-right-radius: 5px;
    }

    .course-table tbody td {
        padding: .7em 1em;
        border-bottom: 1px solid rgba(183, 151, 47, .3);
        font-size: .95em;
    }

    .course-table tbody tr:last-child td {
        border-bottom: none;
    }

    .course-day-cell {
        font-weight: 700;
        color: #b7972f;
        text-transform: uppercase;
        vertical-align: middle;
        border-right: 1px solid rgba(183, 151, 47, .3);
    }

    .course-cards-mobile {
        display: flex;
        flex-direction: column;
        gap: 1em;
    }

    .course-day-card {
        border: 1px solid #b7972f;
        border-radius: 6px;
        background-color: #14141a;
        overflow: hidden;
    }

    .course-day-card-title {
        background: linear-gradient(90deg, #1c140a 0%, #4a3414 50%, #1c140a 100%);
        color: #f0d98c;
        text-transform: uppercase;
        font-weight: 700;
        text-align: center;
        padding: .6em;
        border-bottom: 2px solid #b7972f;
    }

    .course-card-item {
        color: #fff;
        padding: .8em 1em;
        border-bottom: 1px solid rgba(183, 151, 47, .3);
    }

    .course-card-item:last-child {
        border-bottom: none;
    }

    .course-card-item-header {
        display: flex;
        justify-content: space-between;
        align-items: baseline;
        gap: .5em;
    }

    .course-card-horaire {
        color: #b7972f;
        font-weight: 700;
    }

    .course-card-niveau {
        font-size: .85em;
        color: #ddd;
        text-align: right;
    }

    .course-card-cours {
        font-weight: 600;
        margin-top: .2em;
    }

    .course-card-meta {
        font-size: .85em;
        color: #bbb;
        margin-top: .2em;
    }

    @media (max-width: 576px) {
        .titre-course-home {
            min-height: 0;
        }

        .titre-course-home-text {
            font-size: 2.2em;
        }
    }
</style>